module.exports = __webpack_public_path__ + "img/pothole-balkan.09c73c88.png";